export default __webpack_public_path__ + "static/media/santa-maria-10.56dd1d38.jpg";